export enum FetchUrl {
  SEND_MAIL_TO_ADMINS = "sendMailToAdmins",
  SEND_MAIL = "sendMail",
}
